import { render, staticRenderFns } from "./KurumKurulus.vue?vue&type=template&id=f3a77480&"
import script from "./KurumKurulus.vue?vue&type=script&lang=js&"
export * from "./KurumKurulus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports